export function validateCrawlerUrl(url, localizeMessage) {
  if (!url) {
    return {
      valid: false,
      error: localizeMessage('wizard.connectivity.error.baseUrlNotConfigured'),
    };
  }
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return {
      valid: false,
      error: localizeMessage('wizard.connectivity.error.invalidUrlFormat'),
    };
  }
  return { valid: true };
}
